import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content border" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "h2 mb-0" }
const _hoisted_6 = { class: "modal-body border-0" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["id", "data-bs-target"]

import { EModal } from '@/enums';
import useModals from './useModals';
import { ConfirmModalResponse } from './modals.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    title: {},
    message: {},
    confirmText: { default: 'Confirmar' },
    cancelText: { default: 'Fechar' }
  },
  emits: ["onAction"],
  setup(__props: any, { emit: __emit }) {

const id = EModal.confirm
const { toggleModal } = useModals()

const props = __props

const emits = __emit

const handleAction = (action: ConfirmModalResponse) => {
  toggleModal(id)
  emits('onAction', action)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      tabindex: "-1",
      id: _unref(id),
      "data-bs-backdrop": true,
      "aria-labelledby": "confirmModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _cache[2] || (_cache[2] = _createElementVNode("i", {
              type: "button",
              class: "fas fa-times text-muted",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.message), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAction('cancel'))),
              class: "btn btn-outline-dark btn-sm"
            }, _toDisplayString(_ctx.cancelText), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAction('confirm'))),
              class: "btn btn-dark btn-sm"
            }, _toDisplayString(_ctx.confirmText), 1)
          ])
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("button", {
      hidden: "",
      id: `trigger-${_unref(id)}-btn`,
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_unref(id)}`
    }, null, 8, _hoisted_8)
  ], 64))
}
}

})